/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Claims } from './Claims';
import {
    ClaimsFromJSON,
    ClaimsFromJSONTyped,
    ClaimsToJSON,
} from './Claims';

/**
 * 
 * @export
 * @interface ClientPrincipal
 */
export interface ClientPrincipal {
    /**
     * 
     * @type {string}
     * @memberof ClientPrincipal
     */
    identityProvider?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPrincipal
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPrincipal
     */
    userDetails?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientPrincipal
     */
    userRoles?: Array<string> | null;
    /**
     * 
     * @type {Array<Claims>}
     * @memberof ClientPrincipal
     */
    claims?: Array<Claims> | null;
    /**
     * 
     * @type {string}
     * @memberof ClientPrincipal
     */
    accessToken?: string | null;
}

/**
 * Check if a given object implements the ClientPrincipal interface.
 */
export function instanceOfClientPrincipal(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClientPrincipalFromJSON(json: any): ClientPrincipal {
    return ClientPrincipalFromJSONTyped(json, false);
}

export function ClientPrincipalFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientPrincipal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'identityProvider': !exists(json, 'identityProvider') ? undefined : json['identityProvider'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userDetails': !exists(json, 'userDetails') ? undefined : json['userDetails'],
        'userRoles': !exists(json, 'userRoles') ? undefined : json['userRoles'],
        'claims': !exists(json, 'claims') ? undefined : (json['claims'] === null ? null : (json['claims'] as Array<any>).map(ClaimsFromJSON)),
        'accessToken': !exists(json, 'accessToken') ? undefined : json['accessToken'],
    };
}

export function ClientPrincipalToJSON(value?: ClientPrincipal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'identityProvider': value.identityProvider,
        'userId': value.userId,
        'userDetails': value.userDetails,
        'userRoles': value.userRoles,
        'claims': value.claims === undefined ? undefined : (value.claims === null ? null : (value.claims as Array<any>).map(ClaimsToJSON)),
        'accessToken': value.accessToken,
    };
}

